import type { PayloadAction } from '@reduxjs/toolkit';
import type { SignInPayload, UserInformationState, UserState } from 'features/user/types';
import { createSlice } from 'utils/@reduxjs/toolkit';

export const initialState: UserState = {
  authorized: false,
  handling: false,
};

const slice = createSlice({
  name: 'userStore',
  initialState,
  reducers: {
    fetchInformation(state, action: PayloadAction<UserInformationState | null>) {
      state.information = action.payload ?? undefined;
      state.authorized = true;
      state.handling = false;
    },
    selectUnit(state, action: PayloadAction<string>) {
      if (state.information) {
        state.information.activeUnit = action.payload;
      }
    },
    signedIn(state, _action: SignInPayload) {
      state.handling = true;
      state.information = undefined;
      state.authorized = false;
    },
    signOut(state) {
      state.information = undefined;
    },
  },
});

export const { actions, name: key, reducer } = slice;
